const votingMixin = {
	computed: {
	},
	methods: {
		__isVotingStv(voting) {
			let votingSettings = voting.settings;
			if (typeof votingSettings === 'string') votingSettings = JSON.parse(votingSettings);
			const isStv = votingSettings.is_single_transferable_vote;
			return isStv;
		},
		__isVotingRollCall(voting) {
			let votingSettings = voting.settings;
			if (typeof votingSettings === 'string') votingSettings = JSON.parse(votingSettings);
			const isStv = votingSettings.is_roll_call;
			return isStv;
		},
		__getVotingTypeLabel(voting) {
			let votingSettings = voting.settings;
			if (typeof votingSettings === 'string') votingSettings = JSON.parse(votingSettings);
			const isStv = votingSettings.is_single_transferable_vote;
			const isRollCall = votingSettings.is_roll_call;
			const isCustom = voting.type === 'custom';
			let type = this.$t(voting.type);
			if (isStv) type = this.$t('STV');
			else if (isRollCall) type = this.$t('Roll call');
			else if (isCustom) type = this.$t('Majority vote');
			return type;
		},
	},
	mounted() {
	},
};

export default votingMixin;
